// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"67":"web3","226":"web3-provider","875":"web3modal"}[chunkId] || chunkId) + "." + {"67":"a87e48a5","226":"ef4f18fb","787":"82e7f94d","875":"0d57b336","948":"5be3e100"}[chunkId] + ".chunk.js";
};